import React from "react";
import { useTranslation } from "react-i18next";

import {
  useRemoveProjectPortfolio,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolioRemoval({ portfolio, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeProjectPortfolio } =
    useRemoveProjectPortfolio(portfolio);
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <Modal
      header={t("removeProjectPortfolio.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.portfolioRemoval}>
        <div className={styles.main}>
          <p className={styles.text}>
            {t("removeProjectPortfolio.group")}{" "}
            <span className={styles.name}>{portfolio.name}</span>{" "}
            {t("removeProjectPortfolio.removal")}
          </p>
          <div className={styles.buttons}>
            <Button type="cancel" press={cancel}>
              {t("removeProjectPortfolio.cancel")}
            </Button>
            <Button
              type="delete"
              status={isRequestPending ? "pending" : "none"}
              press={() => removeProjectPortfolio({ portfolio, planzone })}
            >
              {t("removeProjectPortfolio.confirm")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export { ProjectPortfolioRemoval };
